import { Component, ViewEncapsulation, input, computed } from '@angular/core';
import { CardItemComponent, CardItemData } from '../../molecules/card-item/card-item';

@Component({
  selector: 'ds-cards-block',
  templateUrl: './cards-block.html',
  styleUrl: './cards-block.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [CardItemComponent],
})
export class CardsBlockComponent {
  readonly columns = input<2 | 3 | 4 | 5>(3);
  readonly cards = input.required<CardItemData[]>();

  readonly cssClass = computed(
    () => `s__cards-block s__cards-block--cols-${this.columns()}`,
  );
}
